<template>
  <div>
    <!-- タブボタン部分 -->
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a href="#tab1" class="nav-link active" data-toggle="tab"
          >ファイル発注</a
        >
      </li>
    </ul>

    <!--タブのコンテンツ部分-->
    <div class="tab-content" v-scrollbar>
      <div id="tab1" class="tab-pane active">
        <h2 class="hdg_order01"><i></i>発注内容</h2>

        <div>
          <table class="table table-bordered bg-white tbl_master01 text-center">
            <tbody>
              <tr>
                <th class="bg-tbl-light">取込件数</th>
                <td>{{ captureCount }}</td>
                <th class="bg-tbl-light">選択件数</th>
                <td>{{ selectedInputNo.length }}件</td>
                <th class="bg-tbl-light">エラー件数</th>
                <td>{{ errCount }}</td>
                <th class="bg-tbl-light">要確認件数</th>
                <td>{{ warnCount }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2 class="hdg_order01 mt40"><i></i>ファイル発注ご確認</h2>
        <div class="table-responsive">
          <table class="table table-bordered bg-white tbl_file01 text-nowrap">
            <thead>
              <tr class="bg-tbl-head text-white text-center">
                <th style="min-width: 10em;" v-for="i in uploadColumn" :key="i">
                  {{ uploadHeader[`field${i.toString().padStart(3, 0)}`] }}
                </th>
                <th>[変換後]お届け先コード</th>
                <th>[変換後]お届け先名</th>
                <th>[変換後]お届け先郵便番号</th>
                <th>[変換後]お届け先住所</th>
                <th>[変換後]製品コード</th>
                <th>[変換後]品番名</th>
                <th>[変換後]規格名</th>
                <th>[変換後]色名</th>
                <th>[変換後]需要家コード</th>
                <th>[変換後]需要家名</th>
              </tr>
            </thead>
            <tbody>
              <tr
                :id="`order${order.row_no}`"
                v-for="order in uploadOrders"
                :key="order.row_no"
              >
                <td
                  class="td_file_input"
                  v-for="i in uploadColumn"
                  :key="i"
                  :class="txtColor(order, i)"
                >
                  {{ order[`field${i.toString().padStart(3, 0)}`] }}
                </td>
                <td class="td_file_input">
                  {{ order.delivery_cd }}
                </td>
                <td class="td_file_input">
                  {{ order.dlcompany_na }}
                </td>
                <td class="td_file_input">
                  {{ order.dlpost_no }}
                </td>
                <td class="td_file_input">
                  {{ order.dladdress_na }}
                </td>
                <td class="td_file_input">
                  {{ order.item_cd }}
                </td>
                <td class="td_file_input">
                  {{ order.part_na }}
                </td>
                <td class="td_file_input">
                  {{ order.stand_na }}
                </td>
                <td class="td_file_input">
                  {{ order.color_na }}
                </td>
                <td class="td_file_input">
                  {{ order.clcompany_cd }}
                </td>
                <td class="td_file_input">
                  {{ order.clcompany_na }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="alert alert-danger" v-if="confirmMessage">
          {{ confirmMessage }}
        </div>

        <div class="btn-center btn_order_confirm">
          <router-link :to="{ name: 'order-file' }" class="btn btn-primary"
            ><i class="fa fa-arrow-left" aria-hidden="true"></i
            >戻る</router-link
          >

          <button @click="addOrderHandler" class="btn btn-order btn-lg">
            確定し注文する<i class="fa fa-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
        <!-- <div
          class="box_confirm"
          v-if="
            order_screen_ptn_di == 'A02' ||
              order_screen_ptn_di == 'A03' ||
              order_screen_ptn_di == 'A04' ||
              order_screen_ptn_di == 'A05'
          "
        >
          ご発注後の修正および取消し処理については<br />
          送信No.をご確認のうえ、お電話にてご連絡をお願いいたします。<br />
          <br />
          電話番号：0120-21-6270
        </div> -->
        <div class="box_attention" v-if="order_screen_ptn_di == 'A01'">
          <strong>まだご注文は完了しておりません。</strong><br />
          内容をご確認の上、「確定し注文する」ボタンを押してください。
        </div>
      </div>
      <!-- ファイル発注ご確認 -->
    </div>
  </div>
</template>

<script>
import { store as FileOrderStore } from "../../../../store/FileOrder";

export default {
  data() {
    return {
      confirmMessage: ""
    };
  },
  computed: {
    uploadHeader() {
      return FileOrderStore.uploadHeader;
    },
    uploadColumn() {
      return FileOrderStore.uploadColumn;
    },
    uploadOrders() {
      return FileOrderStore.uploadOrders.filter(row =>
        this.selectedInputNo.some(no => row.input_no === no)
      );
    },
    uploadFileName() {
      return FileOrderStore.uploadFileName;
    },
    selectedInputNo() {
      return FileOrderStore.selectedInputNo;
    },
    selectedFile() {
      return FileOrderStore.selectedFile;
    },
    captureCount() {
      return FileOrderStore.captureCount;
    },
    errCount() {
      return FileOrderStore.errCount;
    },
    warnCount() {
      return FileOrderStore.warnCount;
    },
    order_screen_ptn_di() {
      return FileOrderStore.order_screen_ptn_di;
    }
  },
  beforeMount() {
    if (!this.uploadFileName) {
      this.$router.replace({ name: "order-file" });
    }
  },
  methods: {
    async addOrderHandler() {
      const response = await this.postAsteria("FileOrder", "addOrder", {
        filename: this.uploadFileName,
        inputno: this.selectedInputNo
      });

      if (response.responseData.return != 0) {
        if (response.responseData.return != 9) {
          window.alert("ファイル発注に失敗しました");
        }
        this.confirmMessage = response.responseData.message;
        return;
      }

      // 伝票番号を保存
      FileOrderStore.denpyou_no = response.responseData.denpyouNo;
      FileOrderStore.orderCount = response.responseData.orderCount;

      // データ初期化
      FileOrderStore.uploadHeader = [];
      FileOrderStore.uploadColumn = [];
      FileOrderStore.uploadOrders = [];
      FileOrderStore.uploadFileName = "";
      FileOrderStore.selectedInputNo = [];
      FileOrderStore.selectedFile = null;

      this.$router.push({ name: "order-file-thanks" });
      return response;
    },

    txtColor: function(order, col) {
      if (1 == order[`field${col.toString().padStart(3, 0)}_worn_di`]) {
        return "txt_warning";
      }
    }
  }
};
</script>
